import { ProductEntity, ProductLocalizedEntity } from 'src/modules/products';

export const getProductName = (localizedProduct: ProductLocalizedEntity) => {
  return localizedProduct.name;
};

export const getProductDetailsURL = (product: ProductEntity) => {
  return `/products/${product.product_categories[0]?.slug || 'category'}/${product.slug}`;
};
